const {gql} = require('graphql-tag');
export default gql`
  mutation removeFilm($id: ID!) {
    removeFilm(id: $id) {
      id
    }
  }
`;
